import { useMemo } from 'react';
import type { FolderMenuItemsContextValue } from '@/containers/Workspace.Folder/Context';
import { FolderMenuItemsContext } from '@/containers/Workspace.Folder/Context';
import { FolderActionsContainer } from '@/containers/Workspace.Folder/FolderMenuContainer';
import type { IWorkspaceFolderItem } from '@/types';
import { FolderActionsContextMenuPopper } from '../Workspace.Folder/Folder.Actions.ContextMenu';

type Props = {
  data: IWorkspaceFolderItem;
};

export const FolderActionsContextMenu = ({ data }: Props) => {
  const menu: FolderMenuItemsContextValue = useMemo(() => ({
    canChangeOwner: data.capabilities.canChangeOwner,
    canDelete: data.capabilities.canDelete,
    canManageAccess: data.capabilities.canManageAccess,
    canMove: data.capabilities.canMove,
    canRename: data.capabilities.canRename,
    canTranscribe: false,
    canViewTranscript: false,
    canImportTranscript: false,
    canAddChildren: data.capabilities.canAddChildren,
  }), [
    data.capabilities,
  ]);

  return (
    <FolderMenuItemsContext.Provider value={menu}>
      <FolderActionsContainer
        folder={data.folder}
        object={data.object}>
        <FolderActionsContextMenuPopper />
      </FolderActionsContainer>
    </FolderMenuItemsContext.Provider>
  );
};